import React from 'react';
import Icon, { COLORS, ICONS } from '../icon';
import TooltipWrapper, { TTPosition, TTPositionType } from './tooltip-wrapper';

interface Props {
	message: string;
	position?: TTPositionType;
	below?: boolean;
	left?: boolean;
	right?: boolean;
}

export enum InfoBadgeMsg {
	MediaUpload = '.pdf, .pptx, .key, .jpg, .jpeg, .png, .gif, .aac, .mp3, .wav, .mp4, .mov, .webm\nVideo files may not exceed 5GB',
	BackstageComms = 'Prevents backstage audio from going to live audience. This will also prevent live presenters from communicating with the backstage while in a shot.',
	VideoResolution = 'Manages video resolution of live presenters depending on who is in canvas, or about to be.',
	LoopToggle = 'When toggled on, Loop will make video content play on repeat until the shot is advanced to the next shot.',
	HostCanvasVolume = 'Adjust the in-room audio levels of the canvas. This will not effect the Stream volume.',
	CanvasVolume = 'Reflects the canvas volume within Greenroom. The Stream will always output at 100% volume.',
	Background = 'Background shows behind live streams.',
	Wallpaper = 'Wallpaper shows when you press the "Clear" button on the showboard.',
	DebugPanel = 'Enables the debug panel for testing.',
	AudienceTabSetting = 'Allow your presenters to see and reply to the audience page chat feed. They will not be able to hide or save chats.'
}

export default function InfoBadge(props: Props) {
	const { message = '' } = props;

	let position = TTPosition.above;
	if (props.below) {
		position = TTPosition.below;
	} else if (props.right) {
		position = TTPosition.right;
	} else if (props.left) {
		position = TTPosition.left;
	}

	return (
		<TooltipWrapper message={message} position={position}>
			<div className="info-i-tooltip">
				<Icon name={ICONS.INFO_OUTLINE} size={16} color={COLORS.DEFAULT_GRAY} />
			</div>
		</TooltipWrapper>
	);
}
